"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultilineText = void 0;
var multiline_text_component_1 = require("./multiline-text.component");
Object.defineProperty(exports, "MultilineText", { enumerable: true, get: function () { return multiline_text_component_1.MultilineText; } });
